import { render, staticRenderFns } from "./create-membership_coupon.vue?vue&type=template&id=6c87ce6d&scoped=true"
import script from "./create-membership_coupon.vue?vue&type=script&lang=js"
export * from "./create-membership_coupon.vue?vue&type=script&lang=js"
import style0 from "./create-membership_coupon.vue?vue&type=style&index=0&id=6c87ce6d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c87ce6d",
  null
  
)

export default component.exports